import ApiService from "@/core/services/api.service";

const state = {
  items: [],
  pagination: {},
  filters: {
    base: null,
  },
};

const actions = {
  /**
   * Fetch async.
   *
   * @param context
   * @returns {Promise<*>}
   */
  async fetchAssignedEmployeeListForLeave(context) {
    try {
      ApiService.setHeader();
      const response = await ApiService.query("employee/record", {
        params: {
          "page[size]": 30,
          "page[number]": state.pagination.current_page ?? 1,
          type_id: 2,
          "filter[base]": state.filters?.base,
        },
      });

      context.commit("setAssignedEmployeeListForLeave", response.data.data);
      context.commit(
        "setAssignedEmployeeListForLeavePagination",
        response.data.meta.pagination
      );

      return response.data.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  /**
   *
   * @param context
   * @param payload
   */
  changeAssignedEmployeeListForLeaveBaseFilter(context, payload) {
    const filters = state.filters;
    filters.base = payload.base;

    context.commit("setAssignedEmployeeListForLeaveFilters", filters);
  },
};

const mutations = {
  /**
   *
   * @param state
   * @param data
   */
  setAssignedEmployeeListForLeave(state, data) {
    state.items = data;
  },

  /**
   *
   * @param state
   * @param pagination
   */
  setAssignedEmployeeListForLeavePagination(state, pagination) {
    state.pagination = pagination;
  },

  /**
   *
   * @param state
   * @param currentPage
   */
  setAssignedEmployeeListForLeavePage(state, currentPage) {
    state.pagination.current_page = currentPage;
  },

  /**
   * Set filters.
   *
   * @param state
   * @param filters
   */
  setAssignedEmployeeListForLeaveFilters(state, filters) {
    state.filters = filters;
  },
};

const getters = {
  getAssignedCompanyLeaveEntitlementList: (state) => state.items,
  getAssignedCompanyLeaveEntitlementListPagination: (state) => state.pagination,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
